import React from 'react';
import Immutable from 'immutable';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Node,
} from '@uncinc/react-drupal-core';

import {
  ImmutableEntity,
  Pager,
} from '@uncinc/react-drupal-core/types';

import { NodePartner } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface ViewPartnersOverviewProps {
  entities: Immutable.List<ImmutableEntity<NodePartner>>;
  pager: Immutable.List<ImmutableEntity<Pager>>;
}

const ViewPartnersOverview: React.FC<ViewPartnersOverviewProps> = ({
  entities,
}) => (
  <Container>
    <div className="ViewPartnersOverview">
      <div className="row">
        {entities.map((entity) => {
          const partner = entity.toJS();

          const id = partner.nid[0].value;
          const uuid = partner.uuid[0].value;
          const langcode = partner.langcode[0].value;
          const key = `${uuid}:${langcode}`;

          return (
            <div className="col-12 col-md-6 col-lg-4" key={key}>
              <Node
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
    </div>
  </Container>
);

export default ViewPartnersOverview;
